import { AxiosInstance } from 'axios';
import client from './RestClient';

export interface AecoSignWebService {
  getFullSpaceIds(
    channelGroupId: number,
    startDate: string,
    endDate: string,
    testMode: boolean,
    campaignId?: number | null
  ): Promise<string[]>;
}

export class RestfulAecoSignWebService implements AecoSignWebService {
  constructor(private restClient: AxiosInstance = client) {}

  /**
   * 走期內已經被 10 個活動綁滿、不能再選的電子紙版位（ECOPD-5616）。
   *
   * query 用 snake_case——後端這支端點是這樣定義的，不是這個 repo 的慣例。
   *
   * 🔴 編輯既有活動時 `campaignId` 一定要帶：後端會把那檔活動自己從佔用數扣掉，
   * 不帶的話使用者一進編輯就會看到自己現在鎖著的機台變灰、存不回去。
   *
   * ⚠️ 空清單不只代表「沒有機台滿」，也可能是「這個渠道沒綁發佈商」或
   * 「渠道發佈商 ∩ 代理商授權 = 空」。呼叫端不該從空清單推論任何其他事。
   */
  async getFullSpaceIds(
    channelGroupId: number,
    startDate: string,
    endDate: string,
    testMode: boolean,
    campaignId?: number | null
  ): Promise<string[]> {
    const response = await this.restClient.get('/v2/aecosign/full-space-ids', {
      params: {
        channel_group_id: channelGroupId,
        start_date: startDate,
        end_date: endDate,
        test_mode: testMode,
        // 用 != null 而不是真假值判斷：活動 id 理論上不會是 0，但「0 當成沒帶」是個
        // 藏在呼叫端看不到的假設，與 space-deliverability-preview 那支的 `?? null` 也不一致。
        ...(campaignId != null ? { campaign_id: campaignId } : {})
      }
    });
    return response.data.records;
  }
}
